import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const baseClasses = `
    relative inline-flex items-center justify-center px-8 py-4 
    text-lg font-bold text-white uppercase tracking-wider
    bg-gradient-to-r from-brand-cyan to-brand-purple
    rounded-lg overflow-hidden transition-all duration-300
    hover:scale-105 active:scale-95 animate-pulse-glow
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href?.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    onClick?.();
  };
  const content = <>
      <span className="relative z-10 flex items-center gap-2 drop-shadow-md" data-id="element-241">
        {children}
      </span>
      <div className="absolute inset-0 bg-gradient-to-r from-brand-purple to-brand-cyan opacity-0 hover:opacity-100 transition-opacity duration-500 z-0" data-id="element-242" />
    </>;
  if (href) {
    return <motion.a href={href} onClick={handleClick} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} className={baseClasses} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-243">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} className={baseClasses} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} data-id="element-244">
      {content}
    </motion.button>;
}